import React from "react";
import { useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import FilePaymentDetail from "./FilePaymentDetail";
import FilePaymentFilter from "./FilePaymentFilter";
import { Box } from "@mui/material";

const FilePaymentIntegration = () => {
  const showDetailCreate = useSelector(
    (state) => state.filePayment.HideComponents.showGridComponent
  );

  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <FilePaymentFilter />
        <Box sx={{ marginTop: "12px" }}>
          {showDetailCreate && <FilePaymentDetail />}
        </Box>
      </Box>
      <StlapFooter />
    </>
  );
};

export default FilePaymentIntegration;
